<template>
  <v-row dense>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="text-h6">
            {{ $t('header') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('scaleSheetProfileHeaderTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.ticketNumber"
        :rules="[rules.required]"
        :label="$t('ticketNumber')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.setting"
        :label="$t('setting')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.tract"
        :label="$t('tract')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.destination"
        :label="$t('destination')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.contractAccount"
        :label="$t('contractAccount')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.product"
        :label="$t('product')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.weighedOutAt"
        :label="$t('weighedOutAt')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.inWeight"
        :label="$t('inWeight')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.outWeight"
        :label="$t('outWeight')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.netWeight"
        :rules="[rules.required]"
        :label="$t('netWeight')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.trailerIdentifier"
        :label="$t('trailerIdentifier')"
        outlined
        maxLength="10"
        counter="10"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="text-h6">
            {{ $t('log') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('scaleSheetProfileLogTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.species"
        :rules="[rules.required]"
        :label="$t('species')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.buttLog"
        :rules="[rules.required]"
        :label="$t('buttLog')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentOne') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentOneInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGrade"
        :label="$t('segmentOneGrade')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneEndUseSort"
        :label="$t('segmentOneEndUseSort')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneLength"
        :rules="[rules.required]"
        :label="$t('segmentOneLength')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDiameter"
        :rules="[rules.required]"
        :label="$t('segmentOneDiameter')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGrossVolume"
        :label="$t('segmentOneGrossVolume')"
        :rules="segmentOneVolumeRules"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneNetVolume"
        :rules="segmentOneVolumeRules"
        :label="$t('segmentOneNetVolume')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDefectVolume"
        :label="$t('segmentOneDefectVolume')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentTwo') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentTwoInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGrade"
        :label="$t('segmentTwoGrade')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoEndUseSort"
        :label="$t('segmentTwoEndUseSort')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoLength"
        :label="$t('segmentTwoLength')"
        outlined
        :rules="segmentTwoRules"
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDiameter"
        :label="$t('segmentTwoDiameter')"
        outlined
        :rules="segmentTwoRules"
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGrossVolume"
        :label="$t('segmentTwoGrossVolume')"
        :rules="segmentTwoVolumeRules"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoNetVolume"
        :label="$t('segmentTwoNetVolume')"
        outlined
        :rules="segmentTwoVolumeRules"
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDefectVolume"
        :label="$t('segmentTwoDefectVolume')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentThree') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentThreeInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeLength"
        :label="$t('segmentThreeLength')"
        :rules="segmentThreeRules"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeDiameter"
        :label="$t('segmentThreeDiameter')"
        :rules="segmentThreeRules"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeGrossVolume"
        :label="$t('segmentThreeGrossVolume')"
        :rules="segmentThreeVolumeRules"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeNetVolume"
        :label="$t('segmentThreeNetVolume')"
        outlined
        :rules="segmentThreeVolumeRules"
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
  </v-row>
</template>

<script>
import fieldRules from '@/utils/rules.js'
export default {
  name: 'ScaleSheetImportCsvProfileForm',

  props: {
    propProfile: {
      type: Object,
      required: true
    }
  },

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    rules: fieldRules.rules
  }),

  computed: {
    profile: {
      get () {
        return this.propProfile
      },
      set (value) {
        this.$emit('update', value)
      }
    },
    segmentOneVolumeRules () {
      return this.propProfile.segmentOneDiameter &&
        this.propProfile.segmentOneLength &&
        !this.propProfile.segmentOneNetVolume &&
        !this.propProfile.segmentOneGrossVolume
        ? [this.rules.required]
        : []
    },
    segmentTwoRules () {
      return this.propProfile.segmentTwoDiameter ||
        this.propProfile.segmentTwoLength ||
        this.propProfile.segmentTwoNetVolume ||
        this.propProfile.segmentTwoGrossVolume
        ? [this.rules.required]
        : []
    },
    segmentTwoVolumeRules () {
      return this.propProfile.segmentTwoDiameter &&
        this.propProfile.segmentTwoLength &&
        !this.propProfile.segmentTwoNetVolume &&
        !this.propProfile.segmentTwoGrossVolume
        ? [this.rules.required]
        : []
    },
    segmentThreeRules () {
      return this.propProfile.segmentThreeDiameter ||
        this.propProfile.segmentThreeLength ||
        this.propProfile.segmentThreeGrossVolume ||
        this.propProfile.segmentThreeNetVolume
        ? [this.rules.required]
        : []
    },
    segmentThreeVolumeRules () {
      return this.propProfile.segmentThreeDiameter &&
        this.propProfile.segmentThreeLength &&
        !this.propProfile.segmentThreeNetVolume &&
        !this.propProfile.segmentThreeGrossVolume
        ? [this.rules.required]
        : []
    }
  }
}
</script>
